export const QUOTE_STATUSES = {
  Initialized: 'initialized',
  FormInitialized: 'form-initialized', // legacy status
  FormSent: 'form-sent',
  FormIncomplete: 'form-incomplete',
  FormComplete: 'form-complete',
  OnHold: 'on-hold',
  HealthEvaluationRequired: 'health-evaluation-required',
  HealthEvaluationActive: 'health-evaluation-active',
  Quoted: 'quoted',
  BrokerApproved: 'broker-approved',
  QuoteAccepted: 'quote-accepted',
  AwaitingPayment: 'awaiting-payment',
  Complete: 'complete',
  Mta: 'mta',
  QuoteError: 'quote-error',
  Defunct: 'defunct',
  NotTakenUp: 'not-taken-up',
} as const;

export type QuoteStatus = (typeof QUOTE_STATUSES)[keyof typeof QUOTE_STATUSES];

const QUOTE_STATUS_ORDER: Record<QuoteStatus, number | null> = {
  initialized: 0,
  'form-initialized': 0, // legacy status
  'form-sent': 1, // legacy status
  'form-incomplete': 2, // legacy status
  'form-complete': 3, // legacy status
  'on-hold': 4, // legacy status
  'health-evaluation-required': 5, // legacy status
  'health-evaluation-active': 6, // legacy status
  quoted: 7,
  'broker-approved': 8, // legacy status
  'quote-accepted': 9, // legacy status
  'awaiting-payment': 10, // legacy status
  complete: 11,
  mta: null,
  'quote-error': null,
  defunct: null,
  'not-taken-up': null,
};

export function isQuoteStatusBeforeOrEqual(
  status: QuoteStatus,
  statusToCompare: QuoteStatus
) {
  const statusIndex = QUOTE_STATUS_ORDER[status];
  const statusToCompareIndex = QUOTE_STATUS_ORDER[statusToCompare];

  if (statusIndex === null || statusToCompareIndex === null) {
    return false;
  }

  return statusIndex <= statusToCompareIndex;
}

export function isQuoteStatusAfterOrEqual(
  status: QuoteStatus,
  statusToCompare: QuoteStatus
) {
  const statusIndex = QUOTE_STATUS_ORDER[status];
  const statusToCompareIndex = QUOTE_STATUS_ORDER[statusToCompare];

  if (statusIndex === null || statusToCompareIndex === null) {
    return false;
  }

  return statusIndex >= statusToCompareIndex;
}
